"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _dayjs = _interopRequireDefault(require("dayjs"));

var _curry = _interopRequireDefault(require("lodash-es/curry"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var diff = function diff(whatToDiff, firstDate, secondDate) {
  return (0, _dayjs["default"])(firstDate).diff((0, _dayjs["default"])(secondDate), whatToDiff);
};

var _default = (0, _curry["default"])(diff, 3);

exports["default"] = _default;